import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import AuthOrApp from './authOrApp'
import Dashboard from '../dashboard/dashboard';

export default props => {

	return (
		<div id='id-content-wrapper' className='content-wrapper' style={{ paddingBottom: 0, backgroundColor: '#fff' }} >
			<Switch>

				<Route exact path='/' component={Dashboard} />

				<Redirect from='*' to='/' />
			</Switch>
		</div>
	);
	
};
